<template>
  <fragment>
    <AppBody
      title="Marketplace / Consumidor"
      subtitle="Consumidor / Cadastrar - Editar"
    >
      <div class="search-forms">
        <div class="marketplace-consumidor-container02">
          <h1 class="marketplace-consumidor-subtitle">Dados do consumidor</h1>
          <v-divider class="mb-5"></v-divider>
          <v-row>
            <v-col
              cols="6"
              v-if="$marketplace_consumidor.cadastro.dados_cadastrais.foto.have"
            >
              <label class="input-labels">Foto</label>
              <v-text-field
                show-size
                accept="image/png, image/jpeg, image/bmp"
                solo
                placeholder="Importar banner mobile"
                clearable
                class="input-file"
                append-icon="mdi-image-outline"
                :clear-icon="$config.icons.clear"
                :append-outer-icon="
                  $marketplace_consumidor.cadastro.dados_cadastrais.foto.imagem
                    ? 'mdi-eye-outline'
                    : ''
                "
                @click:clear="clearImage()"
                @click:append-outer="
                  previewImage(
                    $marketplace_consumidor.cadastro.dados_cadastrais.foto
                      .imagem
                  )
                "
                @change="
                  getImagem(
                    $marketplace_consumidor.cadastro.dados_cadastrais.foto
                      .object
                  )
                "
                v-model="
                  $marketplace_consumidor.cadastro.dados_cadastrais.foto.imagem
                "
              ></v-text-field>
            </v-col>
            <v-col cols="6" v-else>
              <label class="input-labels">Foto</label>
              <v-file-input
                show-size
                accept="image/png, image/jpeg, image/bmp"
                solo
                placeholder="Importar imagem"
                clearable
                class="input-file"
                prepend-icon=""
                append-icon="mdi-image-outline"
                :clear-icon="$config.icons.clear"
                :append-outer-icon="
                  $marketplace_consumidor.cadastro.dados_cadastrais.foto.imagem
                    ? 'mdi-eye-outline'
                    : ''
                "
                @click:clear="clearImage()"
                @click:append-outer="
                  previewImage(
                    $marketplace_consumidor.cadastro.dados_cadastrais.foto
                      .imagem
                  )
                "
                @change="
                  getImagem(
                    $marketplace_consumidor.cadastro.dados_cadastrais.foto
                      .object
                  )
                "
                v-model="
                  $marketplace_consumidor.cadastro.dados_cadastrais.foto.object
                "
              >
              </v-file-input>
            </v-col>
            <v-col cols="6">
              <label required class="input-labels">País</label>
              <v-autocomplete
                class="textinput"
                placeholder="Selecione o País"
                :items="$config.paises.result"
                v-model="$marketplace_consumidor.cadastro.dados_cadastrais.pais"
                solo
                item-text="dsc"
                item-value="dsc"
                :filter="searchPais"
                :error-messages="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.pais
                "
                @input="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.pais =
                    []
                "
              >
                <template v-slot:selection="{ item }">
                  <div v-if="item ? (paises = item) : null">
                    {{ item.dsc }}
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <div>
            <v-row>
              <v-col cols="6">
                <label required class="input-labels">Nome Completo</label>
                <v-text-field
                  solo
                  placeholder="Insira o nome completo"
                  v-model="
                    $marketplace_consumidor.cadastro.dados_cadastrais.nome
                  "
                  type="text"
                  class="textinput"
                  :error-messages="
                    $marketplace_consumidor.cadastro.dados_cadastrais.error.nome
                  "
                  @input="
                    $marketplace_consumidor.cadastro.dados_cadastrais.error.nome =
                      []
                  "
                >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <label required class="input-labels">Data de Nascimento</label>
                <v-text-field
                  v-model="
                    $marketplace_consumidor.cadastro.dados_cadastrais
                      .dt_nascimento
                  "
                  type="tel"
                  class="textinput"
                  v-mask="['XX/XX/XXXX']"
                  :placeholder="placeholderData"
                  solo
                  append-icon="mdi-calendar-blank-outline"
                  :error-messages="
                    $marketplace_consumidor.cadastro.dados_cadastrais.error
                      .dt_nascimento
                  "
                  @input="
                    $marketplace_consumidor.cadastro.dados_cadastrais.error.dt_nascimento =
                      []
                  "
                >
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-col cols="6">
              <label :required="countryIsBR" class="input-labels">CPF</label>
              <v-text-field
                solo
                placeholder="Insira o documento"
                v-mask="['###.###.###-##']"
                v-model="
                  $marketplace_consumidor.cadastro.dados_cadastrais.documento
                "
                type="text"
                class="textinput"
                :error-messages="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error
                    .documento
                "
                @input="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.documento =
                    []
                "
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <label :required="!countryIsBR" class="input-labels"
                >Passaporte</label
              >
              <v-text-field
                solo
                placeholder="Insira o passaporte"
                v-mask="'XXXXXXXX'"
                v-model="
                  $marketplace_consumidor.cadastro.dados_cadastrais.passaporte
                "
                class="textinput"
                :error-messages="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error
                    .passaporte
                "
                @input="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.passaporte =
                    []
                "
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <label required class="input-labels">E-mail</label>
              <v-text-field
                solo
                placeholder="Insira o e-mail"
                v-model="
                  $marketplace_consumidor.cadastro.dados_cadastrais.email
                "
                type="text"
                class="textinput"
                :error-messages="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.email
                "
                @input="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.email =
                    []
                "
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <label required class="input-labels">Celular</label>
              <v-text-field
                solo
                placeholder="Insira o nº do celular"
                v-mask="['(##) ####-####', '(##) #####-####']"
                v-model="
                  $marketplace_consumidor.cadastro.dados_cadastrais.celular
                "
                type="text"
                class="textinput"
                :error-messages="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error
                    .celular
                "
                @input="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.celular =
                    []
                "
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <label required class="input-labels">Status</label>
              <v-select
                height="48"
                :items="$config.status"
                dense
                solo
                class="textinput"
                v-model="
                  $marketplace_consumidor.cadastro.dados_cadastrais.status
                "
                required
                placeholder="Selecione o status"
                :error-messages="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.status
                "
                @input="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.status =
                    []
                "
              >
              </v-select>
            </v-col>
            <v-col cols="6">
              <label class="input-labels">Idioma</label>
              <v-select
                height="48"
                :items="idiomas"
                dense
                solo
                item-text="key"
                item-value="value"
                class="textinput"
                v-model="
                  $marketplace_consumidor.cadastro.dados_cadastrais.idioma
                "
                placeholder="Selecione o Idioma"
                :error-messages="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.idioma
                "
                @input="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.idioma =
                    []
                "
              >
              </v-select>
            </v-col>
          </v-row>
          <!-- <div class="marketplace-consumidor-form02"> -->
          <div class="marketplace-consumidor-container02">
            <h1 class="marketplace-consumidor-subtitle">Endereço</h1>
            <v-divider class="mb-5"></v-divider>
          </div>
          <v-row>
            <v-col cols="4">
              <label required class="input-labels">CEP</label>
              <v-text-field
                class="textinput"
                placeholder="Insira o CEP"
                solo
                v-mask="['#####-###']"
                v-model="$marketplace_consumidor.cadastro.dados_cadastrais.cep"
                :error-messages="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.cep
                "
                @input="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.cep =
                    []
                "
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <label required class="input-labels">Estado</label>
              <v-autocomplete
                class="textinput"
                placeholder="Selecione o Estado"
                :items="$config.estados.result"
                v-model="
                  $marketplace_consumidor.cadastro.dados_cadastrais.estado
                "
                solo
                item-text="iso_full"
                item-value="iso_full"
                :filter="searchEstado"
                :error-messages="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.estado
                "
                @input="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.estado =
                    []
                "
              >
                <template v-slot:selection="{ item }">
                  <div v-if="item ? (estados = item) : null">
                    {{ item.iso_full }}
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="4">
              <label required class="input-labels">Cidade</label>
              <v-autocomplete
                class="textinput"
                placeholder="Selecione a Cidade"
                :items="$config.cidades.result"
                v-model="
                  $marketplace_consumidor.cadastro.dados_cadastrais.cidade
                "
                solo
                item-text="dsc_lang"
                item-value="iso_full"
                :filter="searchCidade"
                :error-messages="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.cidade
                "
                @input="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.cidade =
                    []
                "
              >
                <template v-slot:selection="{ item }">
                  <div v-if="item ? (cidades = item) : null">
                    {{ item.dsc_lang }}
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <label required class="input-labels">Bairro</label>
              <v-text-field
                class="textinput"
                placeholder="Insira o bairro"
                solo
                v-model="
                  $marketplace_consumidor.cadastro.dados_cadastrais.bairro
                "
                :error-messages="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.bairro
                "
                @input="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.bairro =
                    []
                "
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <label required class="input-labels">Logradouro</label>
              <v-text-field
                class="textinput"
                placeholder="Insira o logradouro"
                solo
                v-model="
                  $marketplace_consumidor.cadastro.dados_cadastrais.logradouro
                "
                :error-messages="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error
                    .logradouro
                "
                @input="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.logradouro =
                    []
                "
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <label required class="input-labels">Número</label>
              <v-text-field
                class="textinput"
                placeholder="Insira o número"
                solo
                v-model="
                  $marketplace_consumidor.cadastro.dados_cadastrais.end_numero
                "
                :error-messages="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error
                    .end_numero
                "
                @input="
                  $marketplace_consumidor.cadastro.dados_cadastrais.error.end_numero =
                    []
                "
              >
              </v-text-field>
            </v-col>
          </v-row>
        </div>
      </div>
      <RegistrationActions
        :fixed="true"
        :loader="$marketplace_consumidor.cadastro.loading"
        :actions="actions"
      />
    </AppBody>
    <ModalVisualizarImagem :image="imagemModal" :size="'consumidor'" />
  </fragment>
</template>

<script>
import marketplaceConsumidorMixins from "@/mixins/Marketplace-Consumidor.mixins.js";
export default {
  name: "ConsumerSettings",
  mixins: [marketplaceConsumidorMixins],
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    RegistrationActions: () =>
      import("@/components/global/RegistrationActions.vue"),
    ModalVisualizarImagem: () =>
      import("@/components/global/modal-visualizar-imagem.vue"),
  },
  metaInfo: {
    title: "Consumidor | Adicionar/Editar | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Consumidor | Adicionar/Editar | ElevenTickets",
      },
    ],
  },
  data() {
    return {
      actions: [
        {
          name: "Salvar",
          action: () => this.saveConsumer(),
        },
        {
          name: "Cancelar",
          action: () => this.$router.push({ name: "marketplaceConsumer" }),
        },
      ],
      paises: [],
      estados: [],
      cidades: [],
      imagemModal: "",
    };
  },
  computed: {
    routeType() {
      return this.$route.params.type;
    },
    countryIsBR: function () {
      if (
        this.$marketplace_consumidor.cadastro.dados_cadastrais.pais === "Brasil"
      ) {
        return true;
      }

      return false;
    },
  },
  methods: {
    saveConsumer() {
      this.$marketplace_consumidor.validarCadastro(this.routeType);
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    searchPais(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.dsc.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    searchEstado(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.iso_full.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    searchCidade(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.dsc_lang.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    previewImage(imagem) {
      document.getElementsByClassName(
        "modal-body-visualizar-imagem"
      )[0].style.display = "flex";
      this.imagemModal = imagem;
    },
    clearImage() {
      this.$marketplace_consumidor.cadastro.dados_cadastrais.foto.imagem = null;
      this.$marketplace_consumidor.cadastro.dados_cadastrais.foto.have = false;
      delete this.$marketplace_consumidor.cadastro.dados_cadastrais.foto.object;
    },
    getImagem(file) {
      const self = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        self.$marketplace_consumidor.cadastro.dados_cadastrais.foto.imagem =
          reader.result;
        self.$marketplace_consumidor.cadastro.dados_cadastrais.foto.have = true;
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    },
  },
  watch: {
    paises(e) {
      this.$config.getEstados(e.id);
    },
    estados(e) {
      this.$config.getCidades(e.id);
    },
    "$marketplace_consumidor.cadastro.dados_cadastrais.cep"(e) {
      if (e.length === 9) {
        this.$axios
          .get(`https://viacep.com.br/ws/${e}/json/`)
          .then(res => {
            if (res.erro) {
              throw new Error();
            }
            this.$marketplace_consumidor.cadastro.dados_cadastrais.pais =
              "Brasil";
            this.$marketplace_consumidor.cadastro.dados_cadastrais.estado =
              res.uf
                ? res.uf
                : this.$marketplace_consumidor.cadastro.dados_cadastrais.estado;
            this.$marketplace_consumidor.cadastro.dados_cadastrais.cidade =
              res.localidade
                ? res.localidade
                : this.$marketplace_consumidor.cadastro.dados_cadastrais.cidade;
            this.$marketplace_consumidor.cadastro.dados_cadastrais.bairro =
              res.bairro
                ? res.bairro
                : this.$marketplace_consumidor.cadastro.dados_cadastrais.bairro;
            this.$marketplace_consumidor.cadastro.dados_cadastrais.logradouro =
              res.logradouro
                ? res.logradouro
                : this.$marketplace_consumidor.cadastro.dados_cadastrais
                    .logradouro;
          })
          .catch(error => {
            console.error(error);
          });
      }
    },
  },
  mounted() {
    this.$config.getPaises();
    if (this.$marketplace_consumidor.consumidorAddOrEdit != "edit") {
      this.$marketplace_consumidor.cadastro.dados_cadastrais.pessoa = "FISICA";
    }
  },
  destroyed() {
    this.$marketplace_consumidor.limpaFormularioDeConsumidor();
  },
};
</script>

<style scoped>
.marketplace-consumidor-subtitle {
  width: 487px;
  font-size: 1em;
  align-self: flex-start;
  margin-top: 20px;
}

.marketplace-consumidor-container02 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: block;
  margin-top: 20px;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
}

.input-file {
  border-radius: 10px;
  width: 100%;
}
</style>
